<template>
	<v-parallax dark v-bind:src="src" height="500">
		<v-layout align-start column justify-center>
			<div class="heading-text">
				<div class="heading-text-wrapper">
					<h2>{{ title }}</h2>
				</div>
			</div>
		</v-layout>
	</v-parallax>
</template>
<script>
export default {
	name: 'ViewHeader',
	props: {
		title: String,
		src: String
	}
};
</script>

<style scoped>
.heading-text {
	padding: 32px;
	background-color: #fff;
	opacity: 0.8;
	margin-top: 32px;
	margin-left: 64px;
	width: 55vw;
}

.heading-text-wrapper {
	width: 100%;
	border-bottom: 2px solid var(--accent-color);
}

.heading-text-wrapper h2 {
	color: #333;
	margin: 0;
}
</style>
